import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';
import { NgIf, NgClass, NgFor, NgStyle } from '@angular/common';

@Component({
    selector: 'app-videos-left-navigation-pane',
    templateUrl: './videos-left-navigation-pane.component.html',
    styleUrls: ['./videos-left-navigation-pane.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, RouterLink, NgClass, NgFor, NgStyle]
})
export class VideosLeftNavigationPaneComponent implements OnInit, OnDestroy {

  public currentRoute = '';
  public currentChannel = '';
  public subscribedChannels;
  private subscription: ISubscription[] = [];
  public hideTopNavbar = true;
  APP_SETTINGS : any;
  screenWidth: number;

  username: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private videoService: VideosService,
    private utilityService: UtilityService,
    private authService: AuthService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
    this.username = this.authService.getUserName();
    this.APP_SETTINGS = APP_SETTINGS;
    this.currentRoute = this.route.snapshot.children[0].url[0].path;
    this.currentChannel = this.route.snapshot.children[0].params['id'];
    // this.subscription.push(this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
      this.subscription.push(this.router.events.subscribe(event => {
        this.currentRoute = this.route.snapshot.children[0].url[0].path;
        this.changeDetector.detectChanges();
        this.currentChannel = this.route.snapshot.children[0].params['id'];
      }));
        
        if (this.currentRoute === 'channels' || this.currentRoute === 'channel-info' || this.currentRoute === 'manage-subscription') {
          this.hideTopNavbar = false;
        } else {
          this.hideTopNavbar = true;
        }
      // }
      if (this.route.snapshot.children[0].params.hasOwnProperty('id')) {
        this.currentRoute = this.route.snapshot.children[0].params['id'];
      }
    // }));
    this.getSubscribedChannelsList();
    this.subscription.push(this.utilityService.channelSubscriptionToggled$.subscribe(value => {
      this.getSubscribedChannelsList();
    }));
  }
  getSubscribedChannelsList() {
    this.videoService.getSubscribedChannels(this.username).subscribe(data => {
      this.subscribedChannels = data;
    });
  }
  broadcastChannelNumber(channelNumber) {
    this.utilityService.publishChannelNumber(channelNumber);
  }
  ngOnDestroy(): void {
    this.subscription.forEach(subcribe => subcribe.unsubscribe());
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
}
